import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  noRequireAuth,
  requireAuth,
  requireAuthBack,
  hideWithoutAuth,
  requireOperation
} from '../../HOC/auth';

import Loadable from 'react-loadable';
import Loading from '../../elements/Loading';
import Login from '../../container/Login';
import NotFound from '../../views/NotFound';

import AssesmentForDataEngineer from '../../container/AssesmentForDataEngineer';
import Assesment from '../../container/Assesment';
import AssesmentHelp from '../../container/AssesmentHelp';
import TermofUse from '../../container/TermofUse';
import Help from '../../container/Help';
import Runass from '../../container/Runass';
import Requesttrans from '../../container/Requesttrans';
import Thankspage from '../../container/Thankspage';
import PropTypes from 'prop-types';
import React from 'react';
import UnknownError from '../../views/UnknownError';

import SignUp from '../../container/Register';
import Signupsuccess from '../../container/Signupsuccess';
import Snowflake from '../../container/Snowflake';
import Translation from '../../container/Translation';
import Createdatafactory from '../../container/Createdatafactory';
import Createdatafactoryupdate from '../../container/Createdatafactoryupdate';
import TranslationApproval from '../../container/TranslationApproval';
import TranslatedCodeRequest from '../../container/TranslatedCodeRequest';
import TranslatedCodeReleaseApproval from '../../container/TranslatedCodeReleaseApproval';
import TransApproveMsg from '../../container/TransApproveMsg';
import PlaceOrderMsg from '../../container/PlaceOrderMsg';
import ResultMsgPage from '../../container/ResultMsgPage';
import TransMsgPage from '../../container/TransMsgPage';
import Link2approve from '../../container/Link2approve';
import Link2approvepage from '../../container/Link2approvepage';
import Link2approverequest from '../../container/Link2approverequest';
import Link2approverequestpage from '../../container/Link2approverequestpage'; //2nd middle page
import Link2releasepage from '../../container/Link2releasepage'; // 3 middle page
import Link2rptd from '../../container/Link2rptd';
import Link2requestorder from '../../container/Link2requestorder'; //2nd page link
import Link2release from '../../container/Link2release'; //3 page linke
import RDownload from '../../container/RDownload';
import Approve from '../../container/Approve';
import Management from '../../container/Management';
import DataPipeline from '../../container/DataPipeline';
import SrcView from '../../container/SrcView';
import BuildCode from '../../container/BuildCode';
import ManagementDFuser from '../../container/ManagementDFuser';
import ManagementDDL from '../../container/ManagementDDL';
import GenerateTestsource from '../../container/GenerateTestsource';
import ManagementDDLjdbc from '../../container/ManagementDDLjdbc';
import ManagementDDLjdbc2 from '../../container/ManagementDDLjdbc2';
import Datafactorymanagement from '../../container/Datafactorymanagement';
import Dashboard from '../../container/Dashboard';
import ApproveData from '../../container/ApproveData';
import Download from '../../container/Download';
import ApproveMsg from '../../container/ApproveMsg';
import EmailValidation from '../../container/EmailValidation';
import ResetPassword from '../../container/ResetPassword';
import PasswordForgot from '../../container/PasswordForgot';
import ChangePassword from '../../container/ChangePassword';
import PasswordForgotMsg from '../../container/PasswordForgotMsg';
import Onboard from '../../container/Onboard';
import ProjectManagement from '../../container/ProjectManagement';
import CreateDataFactoryProject from '../../container/CreateDataFactoryProject';


const localeMatch = '/:locale([a-z]{2}-[A-Z]{2})';

const loadableOptions = {
  loading: Loading,
  delay: 300,
  timeout: 10000
};

const Preview = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'highlighted' */ '../../container/Preview'),
  ...loadableOptions
});

const Review = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'highlighted' */ '../../container/Review'),
  ...loadableOptions
});

const Report = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'highlighted' */ '../../container/Report'),
  ...loadableOptions
});

const Router = ({ location }) => (
  <TransitionGroup>
    <CSSTransition key={location.key} classNames="fade" timeout={1000}>
      <Switch location={location}>
        <Redirect from="/" to="/en-CA/" exact />
        <Redirect from="/login" to="/en-CA/login" exact />
        {/*<Route path='/privacy-policy' component={() => {*/}
        {/*  window.location.href = 'https://google.ca';*/}
        {/*  return null;*/}
        {/*}}/>*/}
        <Route
          path={`${localeMatch}/onboard`}
          component={noRequireAuth(Onboard)}
          exact
        />
        <Route
          path={`${localeMatch}/login`}
          component={noRequireAuth(Login)}
          exact
        />

        <Route
          path={`${localeMatch}/changepassword`}
          component={requireAuth(ChangePassword)}
          exact
        />
        <Route
          path={`${localeMatch}/passwordforgot`}
          component={noRequireAuth(PasswordForgot)}
          exact
        />
        <Route
          path={`${localeMatch}/passwordforgotmsg`}
          component={requireOperation(PasswordForgotMsg)}
          exact
        />
        <Route
          path={`${localeMatch}/shift`}
          component={requireAuth(Snowflake)}
          exact
        />

        <Route
          path={`${localeMatch}/assessment/free/:prj`}
          component={requireAuth((props)=> <Assesment{...props} userType = "free" />)}
          exact
        />
        <Route
          path={`${localeMatch}/assessment/free/:prj/:customer`}
          component={requireAuth((props)=> <Assesment{...props} userType = "free" />)}
          exact
        />

        <Route path={`${localeMatch}/projectmanagement`} component={requireAuth(ProjectManagement)} exact />

        <Route path={`${localeMatch}/projectmanagement/:dataFactory/:dataFactoryId`} component={requireAuth(ProjectManagement)} exact />

        <Route
           path={`${localeMatch}/projectmanagement/:dataFactory/:project/:dataFactoryId`}
          component={requireAuth((props)=> <Assesment{...props} userType = "standard" />)}
          exact
        />
        
        <Route
           path={`${localeMatch}/projectmanagement/back/:dataFactory/:dataFactoryId/:customer`}
           component={requireAuth(ProjectManagement)}
          exact
        />

      

        <Route path={`${localeMatch}/projectmanagement/viewstm/:dataFactory/:project/:dataFactoryId`}
        component={requireAuth((props)=> <Assesment{...props} userType = "standard" />)}
        exact
        />

        <Route
           path={`${localeMatch}/projectmanagement/:dataFactory/:project/:dataFactoryId/:customer`}
          component={requireAuth((props)=> <Assesment{...props} userType = "standard" />)}
          exact
        />

        <Route
           path={`${localeMatch}/projectmanagement/uploaddesign/:dataFactory/:project/:dataFactoryId/:customer/:organization/:projectName/:applicationName`}
          component={requireAuth((props)=> <Assesment{...props} userType = "standard" />)}
          exact
        />

        

        <Route path={`${localeMatch}/termofuse`} component={TermofUse} exact />

        <Route path={`${localeMatch}/help`} component={Help} exact />

        <Route
          path={`${localeMatch}/translation`}
          component={requireAuth(Translation)}
          exact
        />
        <Route
          path={`${localeMatch}/createdatafactory`}
          component={requireAuth(Createdatafactory)}
          exact
        />

       <Route
          path={`${localeMatch}/createdatafactory/:customerid`}
          component={requireAuth(Createdatafactory)}
          // component={requireAuth((props)=> <createdatafactory2{...props} />)}

       />


        <Route
          path={`${localeMatch}/createdatafactoryupdate`}
          component={requireAuth(Createdatafactoryupdate)}
          exact
        />

        <Route
          path={`${localeMatch}/createdatafactoryupdate/:dfid/:customerid`}
          component={Createdatafactoryupdate}
          // component={requireAuth((props)=> <createdatafactory2{...props} />)}

        />

        <Route
          path={`${localeMatch}/management`}
          component={requireAuth(Management)}
          exact
        />
        <Route
          path={`${localeMatch}/datapipeline`}
          component={requireAuth(DataPipeline)}
          exact
        />

        <Route
          path={`${localeMatch}/codeview`}
          component={requireAuth(SrcView)}
        />
        <Route
          path={`${localeMatch}/buildcode`}
          component={requireAuth(BuildCode)}
        />


        <Route
          path={`${localeMatch}/managementDFuser`}
          component={requireAuth(ManagementDFuser)}
          exact
        />

       {/* <Route
          path={`${localeMatch}/managementDFuser/:dfid/:customerid`}
          component={requireAuth(ManagementDFuser)}

        /> */}

        <Route
          path={`${localeMatch}/managementDFuser/:dfid/:customerid/:owner`}
          component={requireAuth(ManagementDFuser)}

        />
         <Route
          path={`${localeMatch}/managementDDL`}
          component={requireAuth(ManagementDDL)}
          exact
        />

         <Route
          path={`${localeMatch}/managementDDL/:dfid/:reponame/:customer/:selectedjdbclength`}
          component={requireAuth(ManagementDDL)}
          />

       <Route
          path={`${localeMatch}/generateTestsource`}
          component={requireAuth(GenerateTestsource)}
          exact
        />

         <Route
          path={`${localeMatch}/generateTestsource/:datafactoryname/:projectname/:dataFactoryId/:projectId/:customer`}
          component={requireAuth(GenerateTestsource)}
          />

        <Route
          path={`${localeMatch}/managementDDLjdbc`}
          component={requireAuth(ManagementDDLjdbc)}
          exact
        />
        <Route
          path={`${localeMatch}/managementDDLjdbc2`}
          component={requireAuth(ManagementDDLjdbc2)}
          exact
        />

         <Route
          path={`${localeMatch}/managementDDLjdbc2/:dfid/:reponame/:customer`}
          component={requireAuth(ManagementDDLjdbc2)}
        />

        <Route
          path={`${localeMatch}/datafactorymanagement`}
          component={requireAuth(Datafactorymanagement)}
          exact
        />
        <Route
          path={`${localeMatch}/dashboard`}
          component={requireAuth(Dashboard)}
          exact
        />

        <Route
          path={`${localeMatch}/download`}
          component={requireAuth(Download)}
          exact
        />

        <Route
          path={`${localeMatch}/`}
          component={requireAuth(Snowflake)}
          exact
        />

        <Route
          path={`${localeMatch}/unknown-error/`}
          component={requireAuth(UnknownError)}
          exact
        />
        <Route status={404} component={NotFound} />




        <Route path={`${localeMatch}/createdatafactoryproject`} component={CreateDataFactoryProject} exact />


      </Switch>
    </CSSTransition>
  </TransitionGroup>
);

Router.propTypes = {
  location: PropTypes.object
};

export default Router;



// WEBPACK FOOTER //
// ./src/components/views/Router/index.js